import { HashRouter, Route, Routes } from 'react-router-dom'
import ScrollToTop from 'react-scroll-to-top'
import Home from './views/home'
import Song from './views/song'
import Footer from './components/footer'
import Nav from './components/nav'
import Quoc from './views/quoc'
import Us from './views/us'
import Loi from './views/loi'
import Moi from './views/moi'
import Anh from './views/anh'
import Vui from './views/vui'

function App () {
  return (
    <HashRouter>
      <Nav />
      <div className='content-app relative z-[-2]'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/bai' element={<Song />} />
          <Route path='/quoc' element={<Quoc />} />
          <Route path='/us' element={<Us />} />
          <Route path='/loi' element={<Loi />} />
          <Route path='/moi' element={<Moi />} />
          <Route path='/anh' element={<Anh />} />
          <Route path='/vui' element={<Vui />} />
        </Routes>
      </div>
      <ScrollToTop className='flex items-center justify-center' smooth />
      <Footer />
    </HashRouter>

  )
}

export default App
